import React, { useEffect, useState, useContext } from 'react';
import {IProps} from './types';
import * as S from './styles';
import * as Tag from '@components/Chips/styles';
import { AuthContext } from '@utils/DOIgnition/AuthContext';
import { useSelector } from 'react-redux';
import selectors from '@state/selectors';
import RemoveIconWhite from '@assets/icons/removeIconWhite';
import Tooltip from '@components/Tooltip';
import Chips from '@components/Chips';
import { CSSProperties } from 'styled-components';
import { emailRegex } from '@utils/userUtils';

const InputTags:React.FC<IProps> = (props) => {
  const [inputValue, setInputValue] = useState<string>("");

  const { userData } = useContext(AuthContext);
  const designAuth = useSelector(selectors.designs.getDesignAuth);

  const handleRemoveTag = (deteleValue: string) => props.onUpdateList(props.list.filter((tagValue: string)=> tagValue!==deteleValue));

  const handleAddTag = (addValue: string) => {
    const addedIndex = props.list.findIndex(email => email === addValue);
    if (addedIndex === -1) props.onUpdateList([...props.list, addValue]);
  }

  const handleOnChange =  (value: string) => { 
    if ( value !== " " &&  value !== ",") setInputValue(value);
  }

  const handleonKeyPress = (e: any) => {
    if ((e?.key === "Enter" || e?.key === " " || e?.key === ",") && inputValue!=="") {
      handleAddTag(inputValue);
      setInputValue("");
    }
  }

  useEffect(() => {
    document.addEventListener("click", handleonClickOutside);
    return () => document.removeEventListener("click", handleonClickOutside);
  }, [inputValue])

  const handleonClickOutside = () => {
    if (inputValue!=="") {
      handleAddTag(inputValue);
      setInputValue("");
    }
  }

  const validateType = (value: string) => {
    let validate: string | undefined = undefined;
    if (props.type==="email"){
      if (value === userData?.profile.email) validate = "Owner e-mail";
      if (designAuth?.usersPermission) {
        designAuth.usersPermission.map(uPermission => {
          if (uPermission.email === value) validate = "E-mail already added"
        })
      }
      if (!value.match(emailRegex)) validate = "E-mail not valid";
    }
    return validate;
  }

  useEffect(() => {
    if (props.onValidateList && props.list.length>0 && props.validateType) {
      let valid: boolean = true;
      props.list.forEach((item: string) => {
        if (validateType(item) !== undefined) valid = false;
      });
      props.onValidateList(valid);
    }
    if (props.onValidateList && props.list.length===0 && props.validateType) props.onValidateList(false);
  }, [props.list])

  return (                            
    <S.Root>
        <S.Container>
        {props.list.map((item: string, index: number) => {
          let validate = props.validateType ? validateType(item) : undefined;
          let style: CSSProperties | undefined = validate === undefined ? undefined : {'color': '#ee3434'};
          return (
          <Tooltip 
            tip={validate} 
            boxStyle={{"marginTop": '-67px'}}
          >
            <Tag.ChipContainer key={index} style={{...style, 'margin': '0px 8px 8px 0px'}} >
              {item}
              <Tag.RemoveIconContainer onClick={() => handleRemoveTag(item)} >
                <RemoveIconWhite />
              </Tag.RemoveIconContainer>
            </Tag.ChipContainer>
          </Tooltip>);
        })}
        <S.Input 
        style={props.list.length==0 ? { 'padding': '8px 5.1px'} : {}}
        value={inputValue} 
        onChange={(e) => handleOnChange(e.target.value)} 
        onKeyPress={(e: any) => handleonKeyPress(e)}
        placeholder={props.list.length==0 ? props.placeholder??"" : ""}/>
      </S.Container>
    </S.Root>
  );
}

export default InputTags;